import { render, staticRenderFns } from "./infacyProjectReception.vue?vue&type=template&id=59c8f00e&"
import script from "./infacyProjectReception.vue?vue&type=script&lang=js&"
export * from "./infacyProjectReception.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports